<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <h1>Data Control</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Data Sections</strong>
                    </div>
                    <div class="form-container">
                        <b-row>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-database p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Templates</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Copy or move templates to other sites </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/data-control/move-templates'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-database p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Bulk Template Edit</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Edit information across multiple selected templates </div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/data-control/bulk-template-edit'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-database p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Move Hierarchy Entities</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Move Area/Site/Users to different Companies</div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/data-control/move-entities'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-database p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">System Users</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Recover deleted system users</div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/data-control/system-users'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="6" md="6">
                                <b-card footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <i class="bg-success fa fa-database p-3 font-2xl mr-3 float-left"></i>
                                        <div class="h5 text-warning mb-0">Plate History</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">Full control of Plate History</div>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/data-control'">Go <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
  name: 'dataControlDashboard',
  components: {
  },
  data () {
    return {
        userObj: {},
    }
  },
  created () {
      this.getUser();
  },
  methods : {
    getUser() {
      return new Promise((resolve, reject) => {
        this.$data.userObj = JSON.parse(localStorage.getItem('user'));
        if (this.$data.userObj.authcode === undefined) {
          this.$router.push('/pages/login');
        }
        if (this.$data.userObj.auth == "Company Users") {
          this.$data.canShowLatestPrintsReport = true;
        }
        else {
          this.$data.canShowLatestPrintsReport = false;
        }
        if (this.$data.userObj.auth == "Super Admin") {
          this.$data.canShowLatestPrintsReport = true;
        }
        else {
          this.$data.canShowLatestPrintsReport = false;
        }
        resolve();
      });
    },
  }
}
</script>
